export class FormDetails {
    name: string;
    submittedDate: Date;
    status: string;
    statusChangeComments: string;
}